import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Card, Button, ListGroup, Image, Spinner, Form, InputGroup, } from 'react-bootstrap';
import { toast } from "react-toastify"; // 🔔 For user notifications
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { getCartItems, removeItemFromCart, increaseQuantity, decreaseQuantity, clearCart } from '../../../redux/cartSlice';
import { placeOrder } from '../../../redux/orderSlice';
import ApplyCouponForm from "../ApplyCoupon/ApplyCoupon";
import { applyCoupon, clearCoupon } from "../../../redux/couponSlice";
import useUserLocation from "../../Hooks/useUserLocation";
import { FaHome, FaBuilding, FaPen, FaTrash } from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";
import RazorpayButton from "../RazorpayButton/RazorpayButton";

const AddressCard = ({ label, address }) => (
  <Card className="mb-3">
    <Card.Body className="d-flex justify-content-between align-items-start">
      <div className="d-flex flex-column">
        <Card.Title>
          {label === "Home" ? <FaHome className="me-2" /> : <FaBuilding className="me-2" />}
          {label}
        </Card.Title>
        <Card.Text>{address}</Card.Text>
        <div className="d-flex">
          <Button variant="outline-success" className="me-2 btn-sm">
            <FaPen />
          </Button>
          <Button variant="outline-danger" className="btn-sm">
            <FaTrash />
          </Button>
        </div>
      </div>

    </Card.Body>
  </Card>
);

const Cart = () => {
  const savedAddresses = [
    { label: "Home", address: "House No. 27 Shakti Khand 4, Indirapuram, Ghaziabad" },
    {
      label: "Work",
      address:
        "XIHI TECHNOLOGY PRIVATE LIMITED, J-53, Budaun Rd, Block J, Sector 63, Noida, Uttar Pradesh 201301",
    },
    {
      label: "Work",
      address: "Coforge Pvt, GF Floor, Tower A Coforge Limited, Yamuna Expressway, Greater Noida",
    },
  ];

  const apiUrl = process.env.REACT_APP_API_URL;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const { cartItems, totalAmount, loading: cartLoading, error: cartError } = useSelector((state) => state.cart);
  const [userCouponCode, setUserCouponCode] = useState("");
  const [cartTotalAmount, setCartTotalAmount] = useState(totalAmount);
  const [storeCode, setStoreCode] = useState(null);
  const [storeDisconunt, setStoreDiscount] = useState(null);
  if (process.env.NODE_ENV === "development") {
    // console.log("userCouponCode cart+++", userCouponCode);
  }
  const { coordinates, address, loading: locationLoading, error: locationError } = useUserLocation();

  const getUserCouponCode = (data) => {
    if (process.env.NODE_ENV === "development") {
      console.log("data+++++++++++", data);
    }
    setUserCouponCode(data);
    setStoreCode(data.couponCode);
    setStoreDiscount(data.discount);
  }

  const handleRemove = (productId) => {
    if (process.env.NODE_ENV === "development") {
      console.log("productId", productId);
    }
    dispatch(removeItemFromCart(productId));
  };

  const handleIncreaseQuantity = (e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(increaseQuantity(productId));
    // dispatch(applyCoupon({ code: storeCode, cartTotal: totalAmount }))
  };

  const handleDecreaseQuantity = (e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(decreaseQuantity(productId));
    // dispatch(applyCoupon({ code: storeCode, cartTotal: totalAmount }))
  };

  const handlePlaceOrder = async () => {
    try {
      setIsAdding(true);
      const orderData = {
        products: cartItems.map((item) => ({
          product: item.product._id,
          quantity: item.quantity,
        })),
        paymentMethod: "COD",
        couponCode: userCouponCode.couponCode
      };

      await dispatch(placeOrder(orderData));
      toast.success("Order placed successfully!");
      dispatch(clearCart());
      setIsAdding(false);
      navigate("/my/order");
    } catch (error) {
      toast.error("Failed to place order.");
    }
  };

  useEffect(() => {
    dispatch(getCartItems());
  }, [dispatch, totalAmount]);

  const finalAmount = useMemo(() => {
    if (userCouponCode?.discount > 0) {
      return userCouponCode?.finalAmount || (totalAmount - userCouponCode.discount);
    }
    return totalAmount;
  }, [userCouponCode, totalAmount]);

  { cartLoading && <p>Loading cart items...</p> }
  { cartError && <p className="text-red-500">Error: {cartError}</p> };

  return (
    <>
      <Container className="mt-5">
        <Row>
          <Col md={12}>
            <h2 className="mb-4 text-center">Your Shopping Cart</h2>
          </Col>
        </Row>
        {cartItems.length === 0 ? (
          <>
            <p className="text-center">Your cart is empty.</p>
            <Link to="/" style={{ display: "block" }} className="margin-auto text-center">Continue Shopping</Link>
          </>
        ) : (
          <Row>

            <Col xl={{ span: 10, offset: 1 }}>
              <Row>
                <Col xl={8} lg={8} sm={12} md={7} xs={12} >
                  <ListGroup className="cart-list-group">
                    {cartItems.map((item) => (
                      <ListGroup.Item key={item.product._id} className="d-flex align-items-center cart-list-group__item">
                        <Image
                          src={`${apiUrl}${item.product.images[0]}` || 'https://via.placeholder.com/100'}
                          alt={item.product.name}
                          width={100}
                          className="rounded me-3"
                        />
                        <div className="flex-grow-1 cart-list-group__item__info">

                          <h5>{item.product.name}</h5>
                          <p className="mb-0">Price: ₹{item.product.price}</p>
                          <p title={item?.product?.description}>Description: {item?.product?.description?.slice(0, 50)}..</p>
                          <div className="d-flex align-items-center">
                            <Button variant="outline-primary" size="sm" className="me-2" onClick={(e) => handleDecreaseQuantity(e, item.product._id)}>-</Button>
                            <span>{item.quantity}</span>
                            <Button variant="outline-primary" size="sm" className="ms-2" onClick={(e) => handleIncreaseQuantity(e, item.product._id)}>+</Button>
                          </div>
                        </div>
                        <AiFillCloseCircle size={20} color="red" className="cart-list-group__item__remove" onClick={() => handleRemove(item.product._id)} />
                        <Button type="button" variant="danger" size="sm" onClick={() => handleRemove(item.product._id)}>
                          Remove</Button>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Col>

                <Col xl={4} lg={4} sm={12} md={5} xs={12}>
                  <Card className="p-3 shadow-sm">
                    <h4>Order Summary</h4>
                    {/* <p>Total Items: {cartItems.length}</p> */}
                    <p>Price Details ({cartItems.length} Items)</p>

                    <ApplyCouponForm
                      cartTotal={totalAmount}
                      getUserCouponCode={getUserCouponCode}
                    />

                    <h6 className="d-flex justify-content-between">Total Product Price: <span>₹{totalAmount.toFixed(2)}</span></h6>
                    {/* <h5 className="d-flex justify-content-between">Total Discount Price: <span>₹{totalAmount.toFixed(2)}</span></h5> */}
                    <h6 className="d-flex justify-content-between">Shipping<span>Free</span></h6>
                    {userCouponCode.discount > 0 && <h5 className="d-flex justify-content-between">Total Discounts: <span>-₹{userCouponCode.discount}</span></h5>}
                    {userCouponCode.discount < 0 && <h5 className="d-flex justify-content-between">Order Total 1 : <span>₹{userCouponCode?.finalAmount?.toFixed(2)}</span></h5>}
                    {userCouponCode.discount && !userCouponCode.discount > 0 && <h5 className="d-flex justify-content-between">Order Total 2: <span>₹{totalAmount.toFixed(2)}</span></h5>}
                    <h6 className="d-flex justify-content-between">Order Total : <span>₹{finalAmount.toFixed(2)}</span></h6>

                    {/* 
                {userCouponCode.discount > 0 && <h5 className="d-flex justify-content-between">Discount: <span>-₹{userCouponCode.discount}</span></h5>}
                <h5 className="d-flex justify-content-between">Shipping<span>Free</span></h5>
                {userCouponCode.discount > 0 && <h5 className="d-flex justify-content-between">Total : <span>₹{userCouponCode?.finalAmount?.toFixed(2)}</span></h5>}
                {!userCouponCode.discount > 0 && <h5 className="d-flex justify-content-between">Total : <span>₹{totalAmount.toFixed(2)}</span></h5>} */}
                    <Button variant="success" className="mt-3 w-100" onClick={handlePlaceOrder} disabled={isAdding}>
                      {isAdding ? 'Proceed...' : 'Proceed to Checkout'}
                    </Button>

                    <Button variant="success" className="mt-3 w-100" onClick={() => navigate("/address")} disabled={isAdding}>
                      {isAdding ? 'Proceed...' : 'Continue'}
                    </Button>
                    <hr />
                    <Card>
                      <RazorpayButton amount={finalAmount} />
                    </Card>
                    <div className="user-location">
                      {/* <h2>My Location:</h2> */}
                      {locationLoading && <p>Loading location...</p>}
                      {locationError && <p style={{ color: "red" }}>Error: {locationError}</p>}
                      {!locationLoading && !locationError && (
                        <>
                          <p>
                            <strong>Coordinates:</strong> {coordinates.lat}, {coordinates.lng}
                          </p>
                          <p>
                            <strong>Address:</strong> {address}
                          </p>
                        </>
                      )}
                      <hr />
                      <div className="change-location">
                        <h5>Change Location</h5>
                        <InputGroup className="mt-3 mb-3">
                          <Button variant="success">Detect my location</Button>
                          <InputGroup.Text>OR</InputGroup.Text>
                          <Form.Control placeholder="Search delivery location" />
                        </InputGroup>
                      </div>
                      <hr />
                      <h5>Your saved addresses</h5>
                      {savedAddresses.map((addr, index) => (
                        <AddressCard key={index} label={addr.label} address={addr.address} />
                      ))}
                    </div>
                  </Card>

                </Col>
              </Row>
            </Col>

          </Row>
        )}
      </Container >
    </>
  );
};

export default Cart;
